import { useEffect, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useAuth from '../../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

export default function AdminOrphanedSteps({ isNavOpen, customRoles }) {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();
  const { t } = useTranslation();
  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  // console.log(auth.userId)
  const fetchSteps = async () => {
    try {
      const res = await axiosPrivate.get('/steps/orphaned');
      setSteps(res.data);
    } catch (err) {
      console.error(err);
      setMessage('Error fetching orphaned steps.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSteps();
  }, []);

  const handleDelete = async (stepId) => {

    try {
      await axiosPrivate.delete(`/steps/${stepId}`, { data: { userId: auth.userId } });
      setSteps(steps.filter(s => s.step_id !== stepId));
      setMessage(t('orphanedSteps.deleteSuccess'));
    } catch (err) {
      console.error(err);
      setMessage(t('orphanedSteps.errorDeleting'));
    }
  };

  const handleAssignRole = async (stepId, roleId) => {
    try {
      await axiosPrivate.patch(`/steps/${stepId}`, {
        userId: auth?.userId,
        role_ids: [roleId],
      });
      setSteps(steps.filter(s => s.step_id !== stepId)); // remove from orphan list
      setMessage(t('orphanedSteps.roleAssigned'));
    } catch (err) {
      console.error(err);
      setMessage(t('orphanedSteps.errorAssigningRole'));
    }
  };

  if (loading) return <p>{t('orphanedSteps.loading')}</p>;

  return (
    <div className={`${isNavOpen ? 'body-squeezed' : 'body'}`}>
      <div className='admin-users tx1'>
        <h2>{t('orphanedSteps.title')}</h2>
        <p style={{ marginBottom: '1em' }}>{t('orphanedSteps.subtitle')}</p>
        {message && <p>{message}</p>}

        {steps.length === 0 ? (
          <p>{t('orphanedSteps.notFound')}</p>
        ) : (
          <table className="styled-table">
            <thead>
              <tr>
                <th>{t('orphanedSteps.name')}</th>
                <th>{t('orphanedSteps.description')}</th>
                <th>{t('orphanedSteps.assignRole')}</th>
                <th>{t('orphanedSteps.delete')}</th>
              </tr>
            </thead>
            <tbody>
              {steps.map(step => (
                <tr key={step.step_id}>
                  <td>{step.step_name}</td>
                  <td>{step.step_description || '—'}</td>
                  <td>
                    <select onChange={e => handleAssignRole(step.step_id, e.target.value)}>
                      <option value="">{t('orphanedSteps.selectRole')}</option>
                      {customRoles.map(r => (
                        <option key={r.role_id} value={r.role_id}>
                          {r.role_name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {confirmDeleteId === step.step_id ? (
                      <>
                        <button
                          className="button-red"
                          onClick={() => handleDelete(step.step_id)}
                          style={{ marginRight: '0.5em' }}
                        >
                          {t('orphanedSteps.confirmDelete')}
                        </button>
                        <button
                          className="button-white"
                          style={{ minWidth: '150px', marginTop: '0.5em' }}
                          onClick={() => setConfirmDeleteId(null)}
                        >
                          {t('orphanedSteps.cancel')}
                        </button>
                      </>
                    ) : (
                      <button
                        className="button-red"
                        onClick={() => setConfirmDeleteId(step.step_id)}
                      >
                        {t('orphanedSteps.delete')}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
